export default class Form {

    constructor(container) {
        this.container = container
        this.fields    = container.querySelectorAll('input[type="text"], input[type="email"], input[type="tel"], textarea, input[type="checkbox"], input[type="file"]')
        this.submit    = container.querySelector('.form__submit')
    }

    registerEvents() {
        this.submit.addEventListener('click', this.handleData.bind(this))
    }

    handleData(e) {
        e.preventDefault()

        for (let i=0, lng=this.fields.length; i<lng; i++)
            this.handleAlert(this.fields[i])

        return this.handleSubmit()
    }

    handleSubmit() {
        
        if (this.container.querySelector('.alert:not(.alert__submit)')) {

            if (this.container.querySelector('.alert__submit'))
                return 

            let el = document.createElement('p')
            el.className = 'alert alert__form alert__submit'
            el.innerHTML = 'Un ou plusieurs champs sont vides ou incorrects…'
            return this.submit.after(el)
        }

        if (this.container.querySelector('.alert__submit'))
            this.container.querySelector('.alert__submit').remove()

        return this.makeRequest()
    }

    makeRequest() {

        let data = new FormData(this.container)

        const xhr = new XMLHttpRequest()

        if (!xhr) return 

        xhr.onreadystatechange = () => {
            if (xhr.readyState === XMLHttpRequest.DONE) {
                if (xhr.status === 200) {
                    let el = document.createElement('p')
                    el.className = 'form__success'
                    el.innerHTML = (successForm) ? successForm : 'Merci.<br>Votre message envoyé.'
                    this.container.parentElement.appendChild(el)
                    this.container.remove()
                } else {
                    let el = document.createElement('p')
                    el.className = 'wrapper--sm alert alert__form alert__submit'
                    el.innerHTML = (errorForm) ? errorForm : 'Oups ! Il semble qu\'une erreur interne se soit produite…<br>Merci de réessayer plus tard.' 
                    this.submit.after(el)
                }
            }
        }

        xhr.open('POST', this.container.getAttribute('action'), true)
        xhr.setRequestHeader('X-Requested-with', 'xmlhttprequest')
        xhr.send(data)
    }

    handleAlert(field) {

        if (field.type === 'file')
            return this.handleFiles(field)

        if (field.getAttribute('name') === 'send_me_your_fax' && field.value)
            return this.botAlert(field)
        
        if (field.hasAttribute('required') && !field.value)
            return this.createEmptyAlert(field)
        
        switch (field.type) {
            case 'email':
                this.pregMatch(field)
                break
            case 'tel':
                this.pregMatch(field)
                break
            case 'checkbox':
                this.handleCheckbox(field)
                break
            default: 
                break
        }

        if (field.classList.contains('field--empty'))
            return this.clearEmpty(field)
    }

    createEmptyAlert(field, str=false) {

        if (field.classList.contains('field--empty'))
            return 

        let msg = (str) ? str : 'Champ obligatoire',
            el  = document.createElement('span')

        el.className = 'alert alert__form'
        el.innerHTML = msg
        field.classList.add('field--empty')

        if (field.classList.contains('field--error'))
            field.classList.remove('field--error')

        if (field.nextElementSibling)
            field.nextElementSibling.remove()

        return field.parentElement.appendChild(el)
    }

    createErrorAlert(field, str=false) {

        if (field.classList.contains('field--error'))
            return 

        let msg = (str) ? str : 'Format incorrect',
            el  = document.createElement('span')
        
        el.className = 'alert alert__form'
        el.innerHTML = msg
        field.classList.add('field--error')

        if (field.classList.contains('field--empty'))
            field.classList.remove('field--empty')

        if (field.nextElementSibling)
            field.nextElementSibling.remove()

        return field.parentElement.appendChild(el)
    }

    pregMatch(field) {

        if (!field.value)
            return 

        let regex = (field.type === 'email') ? /[^\s@]+@[^\s@]+\.[^\s@]+/ : /^(0|\+33)[1-9]([-. ]?[0-9]{2}){4}$/,
            alert = (field.type === 'email') ? 'Format d\'adresse mail recquis: contact@example.com' : 'Format recquis: +33620054144 ou 0620054144'

        if (regex.test(field.value))
            return this.clearError(field)

        if (field.classList.contains('field--error'))
            return 

        return this.createErrorAlert(field, alert)
    }

    handleCheckbox(field) {

        if (!field.hasAttribute('required'))
            return 

        if (field.checked)
            return this.clearCheckbox(field)

        let label = field.parentElement

        if (label.classList.contains('checkbox--required'))
            return 

        let el = document.createElement('span')

        label.classList.add('checkbox--required')
        
        el.className = 'alert alert__form alert__checkbox'
        el.innerHTML = 'Cette case est obligatoire'

        return label.appendChild(el)
    }

    handleFiles(field) {

        if (!field.value)
            return 

        let size = 0 

        console.log(field.files)
            
        for (let i=0; i<field.files.length; i++) {
            if (!field.files[i].size)
                continue
            size += field.files[i].size
        }
            
        if (size > 10000000)
            return this.createErrorAlert(field, 'Le poids total ne doit pas dépasser 10Mo')
        
        if (field.classList.contains('field--error'))
            return this.clearError(field)
    }

    botAlert() {
        let el = document.createElement('p')
        el.className = 'wrapper--sm alert alert__form alert__submit'
        el.innerHTML = 'Oups ! Il semble qu\'une erreur interne se soit produite…<br>Merci de réessayer plus tard.'
        this.submit.after(el)
    }

    clearCheckbox(field) {

        let label = field.parentElement

        if (!label.classList.contains('checkbox--required'))
            return
        
        if (label.querySelector('.alert'))
            label.querySelector('.alert').remove()
    }

    clearError(field) {

        if (field.classList.contains('field--error'))
            field.classList.remove('field--error')
        
        if (field.nextElementSibling)
            field.nextElementSibling.remove()
    }

    clearEmpty(field) {

        if (field.classList.contains('field--empty'))
            field.classList.remove('field--empty')
    
        if (field.nextElementSibling)
            field.nextElementSibling.remove()
    }
}